import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';
import * as moment from 'moment';

import { PeriodStatus } from './period-status';

@entity({ type: 'periods' })
export class Period extends JsonapiEntity<Period> {
  @attribute() description: string;
  @attribute({ name: 'is_active' }) isActive?: boolean;
  @attribute() end_date?: string;
  @attribute() start_date?: string;
  @attribute() slug: string;

  get startAsDate(): Date | null {
    return this.start_date ? new Date(this.start_date) : null;
  }

  get startAsMoment(): moment.Moment | null {
    return convertToValidMoment(this.start_date);
  }

  get endAsDate(): Date | null {
    return this.end_date ? new Date(this.end_date) : null;
  }

  get endAsMoment(): moment.Moment | null {
    return convertToValidMoment(this.end_date);
  }

  status(now: Date): PeriodStatus {
    if (!this.startAsMoment || !this.endAsMoment) {
      return PeriodStatus.UNKNOWN;
    }

    const endOfPeriod = this.endAsMoment.endOf('day');
    const startOfPeriod = this.startAsMoment.startOf('day');

    if (endOfPeriod.isBefore(startOfPeriod)) {
      return PeriodStatus.UNKNOWN;
    } else if (startOfPeriod.isSameOrBefore(now) && endOfPeriod.isAfter(now)) {
      return PeriodStatus.CURRENT;
    } else if (endOfPeriod.isBefore(now)) {
      return PeriodStatus.PAST;
    } else if (startOfPeriod.isAfter(now)) {
      return PeriodStatus.FUTURE;
    }
    return PeriodStatus.UNKNOWN;
  }
}

function convertToValidMoment(dateString: string): moment.Moment | null {
  if (!dateString) {
    return null;
  }
  const asMoment = moment(dateString, moment.HTML5_FMT.DATE, true);
  return asMoment.isValid() ? asMoment : null;
}
